<template>
    <v-list two-line dense>
        <v-list-item v-if="dev">
            <v-list-item-avatar>
                DEV
            </v-list-item-avatar>
            <v-list-item-content>
                Dev ONLY: components/lists/ContactActivity
            </v-list-item-content>
        </v-list-item>
        <v-list-group
                v-for="d in data"
                :key="d.id"
                v-model="d.active"
                :append-icon="icons.arrowdown"
                no-action
                @click="getItem(d,!d.active)"
        >
            <template v-slot:activator>
                <v-list-item-avatar>
                    <v-icon>{{icons[d.icon]}}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        {{d.action}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{new Date(d.dt).toLocaleString()}}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </template>
            <v-card v-if="activedata">
                <v-card-title class="font-weight-light">Sent {{new Date(activedata.dateSent).toDateString()}}</v-card-title>
                <v-card-text>
                    <v-container class="pa-0">
                        <v-row dense>
                            <v-col cols="6" sm="3">To:</v-col>
                            <v-col cols="6" sm="3">{{activedata.to}}</v-col>
                            <v-col cols="6" sm="3">From:</v-col>
                            <v-col cols="6" sm="3">{{activedata.from}}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>Status:</v-col>
                            <v-col class="text-uppercase">{{activedata.status}}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>Sent Time:</v-col>
                            <v-col>{{new Date(activedata.dateSent).toLocaleTimeString()}}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col><span class="text-capitalize">{{activedata.status}}</span> at:</v-col>
                            <v-col>{{new Date(activedata.dateUpdated).toLocaleTimeString()}}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="font-weight-light subtitle-1 px-2" style="border: solid thin #888888;">
                                <v-icon>{{icons.openquote}}</v-icon>
                                {{activedata.body}}
                                <v-icon>{{icons.closequote}}</v-icon>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title>Fetching Data</v-card-title>
                <v-card-text>
                    <v-skeleton-loader
                            class="mx-auto"
                            type="card"
                    ></v-skeleton-loader>
                </v-card-text>
            </v-card>
        </v-list-group>


    </v-list>
</template>

<script>
    import{
      mapState,
      mapActions
    } from 'vuex'
  export default {
    props: {
      data:{
        type: Array,
        required: false,
        default: ()=>{[]}
      }
    },
    components: {},
    name: "ContactActivity",
    data() {
      return {
        activedata:undefined
      }
    },
    computed:{
      ...mapState(['icons','dev'])
    },
    mounted() {
    },
    methods: {
      ...mapActions(['post','get']),
      async getItem(item,fire){
        //the fire flag is set to !what ever the component is at time of click.. if its closed,
        //it will be opening, so fire is set to true or !item.active
        if(!fire){
          this.activedata=undefined
          return
        }
        if(item.action==='sms' && fire){
          console.log('fireing', fire)
          let data = await this.get({path:'api/twilio/twiliorecord/'+item.value})
          this.activedata = data
        }

      }
    }
  }
</script>

<style scoped>

</style>